import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CorrectAnswer from '../../assets/correct_answer.svg'
import information from '../../assets/informationIcon.svg'
import WrongAnswer from '../../assets/wrong_answer.svg'
import InstructionsModal from '../InstructionsModal/InstructionsModal'
import { answerKeyByLang, solutionKeyByLang } from '../../constants/langTypes'
import Mathjax from 'components/Mathjax'

import './MultipleChoiceAnswer.css'

const MultipleChoiceMultipleChoiceAnswer = (props) => {
    const { t, i18n } = useTranslation()
    const [show, setShow] = useState(false)

    const [isCorrectAnswer, setIsCorrectAnswer] = useState(false)
    const [partiallyCorrect, setPartiallyCorrect] = useState([])
    const [currentLng, setCurrentLng] = useState('en')
    let ans = []

    useEffect(() => {
        setCurrentLng(i18n.language)
        props.data.question.answerbyUser = props.data.question.answerbyUser.filter(
            (item) => item != '',
        )
        props.data.question.english_answer.choices?.map((item) => {
            if (item.is_answer) ans.push(item.choiceId)
        })
        props.data.question.answerbyUser.sort().toString() === ans.sort().toString()
            ? setIsCorrectAnswer(true)
            : setIsCorrectAnswer(false)
        if (!isCorrectAnswer) {
            setPartiallyCorrect(
                props.data.question.answerbyUser.filter((item) =>
                    ans.includes(item),
                ),
            )
        }
    }, [i18n.language])
    const findClass = (answerbyUser, choiceId) => {
        let flag = 0
        answerbyUser.map((item) => {
            if (item == choiceId) flag = 1
        })
        if (flag) return 'mockoption2 selected'
        else return 'mockoption2'
    }
    const findClass2 = (answerbyUser, choiceId) => {
        let flag = 0
        answerbyUser.map((item) => {
            if (item == choiceId) flag = 1
        })
        if (flag) return 'option selected'
        else return 'option'
    }
    const findAns = (answerbyUser, choiceId) => {
        if (!isCorrectAnswer && partiallyCorrect.includes(choiceId))
            return 'Correct Answer'
        let flag = 0
        answerbyUser.map((item) => {
            if (item == choiceId) flag = 1
        })
        if (flag) return 'Your Answer'
        else return 'Correct Answer'
    }
    const findAns2 = (answerbyUser, choiceId) => {
        let flag = 0
        answerbyUser.map((item) => {
            if (item == choiceId) flag = 1
        })
        if (flag) return 'Your Answer'
        else return null
    }
    const handleModal = () => {
        setShow(!show)
    }

    return (
        <fieldset className="multiple-choice-answer-container">
            <article style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span className="ans-description">
                    {t('One/More correct answer(s)')}
                </span>
                {props.mock ? (
                    <span className="difficulty-level">
                        {t(
                            props.data.question.lod == 'E'
                                ? 'Easy'
                                : props.data.question.lod == 'M'
                                ? 'Medium'
                                : 'Difficult',
                        )}
                    </span>
                ) : null}
                {!props.mock && (
                    <span style={{ marginBottom: '14px', marginTop: '45px' }}>
                        <img
                            src={information}
                            onClick={handleModal}
                            style={{
                                height: '17px',
                                width: '17px',
                                cursor: 'pointer',
                            }}
                        />
                    </span>
                )}
            </article>
            {show ? <InstructionsModal show={show} multiple={true} /> : ''}
            <div role="listbox" className="multiple-choice-answer">
                {props.data.question[answerKeyByLang[currentLng]]?.choices?.map(
                    (data, i) => {
                        return (
                            <Fragment key={i + 'choice'}>
                                {props.mock && data.is_answer ? (
                                    <div
                                        style={{
                                            textAlign: `${
                                                findAns(
                                                    props.data.question.answerbyUser,
                                                    data.choiceId,
                                                ) == 'Your Answer'
                                                    ? 'start'
                                                    : 'end'
                                            }`,
                                            color: '#2dce89',
                                            fontSize: '15px',
                                            display: `${
                                                !isCorrectAnswer &&
                                                partiallyCorrect.includes(
                                                    data.choiceId,
                                                )
                                                    ? 'flex'
                                                    : 'block'
                                            }`,
                                            justifyContent: 'space-between',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {!isCorrectAnswer &&
                                        partiallyCorrect.includes(data.choiceId) ? (
                                            <div style={{ textAlign: 'start' }}>
                                                <img
                                                    style={{ marginRight: '5px' }}
                                                    src={CorrectAnswer}
                                                />
                                                {t('Your Answer')}
                                            </div>
                                        ) : null}
                                        <div>
                                            <img
                                                style={{ marginRight: '5px' }}
                                                src={CorrectAnswer}
                                            />
                                            {t(
                                                findAns(
                                                    props.data.question.answerbyUser,
                                                    data.choiceId,
                                                ),
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                                {props.mock && data.is_answer == false ? (
                                    <div
                                        style={{
                                            textAlign: 'start',
                                            color: '#f5365c',
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {findAns2(
                                            props.data.question.answerbyUser,
                                            data.choiceId,
                                        ) ? (
                                            <img
                                                style={{ marginRight: '5px' }}
                                                src={WrongAnswer}
                                            />
                                        ) : null}
                                        {t(
                                            findAns2(
                                                props.data.question.answerbyUser,
                                                data.choiceId,
                                            ),
                                        )}
                                    </div>
                                ) : null}
                                <div
                                    className={
                                        props.mock
                                            ? data.is_answer
                                                ? 'mockoption selected'
                                                : findClass(
                                                      props.data.question
                                                          .answerbyUser,
                                                      data.choiceId,
                                                  )
                                            : props.isPreview && data.is_answer
                                            ? 'option correct'
                                            : props.data.question.answerbyUser.includes(
                                                  data.choiceId,
                                              ) === true
                                            ? 'option selected'
                                            : 'option'
                                    }
                                    onClick={() =>
                                        props.mock
                                            ? null
                                            : props.onClick(
                                                  data.choiceId,
                                                  props.data,
                                              )
                                    }
                                >
                                    <span className="option-choice-id">
                                        {data.choiceId}.
                                    </span>
                                    <div role="option">
                                        <Mathjax
                                            html={props.getAppendImgUrl(
                                                `<p>${data.text}</p>`,
                                            )}
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        )
                    },
                )}
                {props.mock ? (
                    <>
                        <div
                            style={{
                                textAlign: 'center',
                                margin: '20px 0px',
                                fontSize: '16px',
                            }}
                        >
                            {props.data.question.answerbyUser.length ? (
                                !isCorrectAnswer ? (
                                    <>
                                        <div
                                            style={{
                                                color: '#f5365c',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {t('Your answer is incorrect!')}
                                        </div>
                                        {/*<div style={{ color: "#a1aeb7", fontWeight: 500 }}>*/}
                                        {/*  Try again*/}
                                        {/*</div>*/}
                                    </>
                                ) : (
                                    <>
                                        <div
                                            style={{
                                                color: '#2dce89',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {t('Your answer is correct!')}
                                        </div>
                                        <div
                                            style={{
                                                color: '#a1aeb7',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {t('Well done here is the solution')}
                                        </div>
                                    </>
                                )
                            ) : null}
                        </div>
                        <div
                            style={{
                                border: '1px solid #00b0f5',
                                justifyContent: 'center',
                                padding: '25px',
                                borderRadius: '10px',
                                overflow: 'auto',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    color: '#00b0f5',
                                }}
                            >
                                {t('Solution')}
                            </div>

                            <Mathjax
                                html={props.getAppendImgUrl(
                                    `<p>${
                                        props.data.question[
                                            solutionKeyByLang[currentLng]
                                        ]
                                    }</p>`,
                                )}
                            />
                        </div>
                    </>
                ) : null}
            </div>
        </fieldset>
    )
}

export default MultipleChoiceMultipleChoiceAnswer
